import { ChatCircleDotsIcon } from '@phosphor-icons/react';

import type { AgentSession } from '@/api-models/agent-sessions';

/**
 * "The agent asked you something and stopped."
 *
 * Rendered *beside* the sandbox status pill rather than instead of it, because the two answer
 * different questions: the pill says what the machine is doing (it may be running, hibernated, or
 * still coming up) and this says whose move it is. Nothing else on a session row can express
 * that — a parked agent has just written an assistant turn, exactly like one that finished
 * replying.
 *
 * Renders nothing when no question is pending, so callers can drop it in unconditionally.
 */
export function AwaitingAnswerChip({ session }: { session: Pick<AgentSession, 'awaiting_user_input_at'> }) {
  if (!session.awaiting_user_input_at) return null;

  return (
    <span
      title="The agent asked a question and is waiting for your answer"
      className="flex shrink-0 items-center gap-1.5 rounded-full bg-warning-tint px-2.5 py-1 text-2xs font-semibold text-warning"
    >
      <ChatCircleDotsIcon size={11} weight="fill" />
      Needs answer
    </span>
  );
}
